module.exports = function(comments) {
	'use strict';
  comments
  .controller('allcommentsController', allcommentsController)
	allcommentsController.$inject = ["cyrilicToLatin","config","highlightWords","watchAllCheckboxesNgTable","$state","API_URL","$stateParams","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService","jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","serverError","comunicateBetweenViews", "offlineError"];
	
  function allcommentsController(cyrilicToLatin,config,highlightWords,watchAllCheckboxesNgTable,$state,API_URL,$stateParams,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval,serverError, comunicateBetweenViews, offlineError) {
    var vmac = this;
    var state = 'comments';
    var status = 'pending';
    var $data;
    var page;
    vmac.postId = null;
    vmac.status = 'pending';
    vmac.parrent = {};
    vmac.statusApproved = false;
    vmac.statusTrash = false;
    $rootScope.emptyTable = false;
    vmac.checkedPostsEdit = [];
    vmac.checkboxes = { 'checked': false, items: {} };
    vmac.checkedPostsforUpdate = [];
    vmac.checkedPostsEdit = [];
    vmac.serchCommentsModalShow = false;
    if($state.current.name =='app.allvideocomments') {
      vmac.commentsType = 'video'
    }
    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
      vmac.adminPermisions = true;
    }
    // vmac.selectedPriorityFilter = {value:'all'}
    var arrayPostsIdFunction = function() {
      if (vmac.checkedPostsEdit.length>0 ) {
        for(var i=0;i<vmac.checkedPostsEdit.length;i++) {
          vmac.checkedPostsforUpdate.push(vmac.checkedPostsEdit[i]);
        }
      }
    }
    vmac.goToPost = function(postId) {
      if(vmac.commentsType == 'video') {
        $state.go('app.allvideos',{id:postId});  
      } else {
        $state.go('app.allposts',{id:postId});
      }
    }
    var putPostsFunction = function(url) {
      var updateDataPosts = {
        "ids": vmac.checkedPostsforUpdate,
      }
      $rootScope.hasLoaded = false;
      var putFunction = function() {
        $http.put(url , updateDataPosts)
        .success(function (data, status, headers) {
            alertService('success','Success ', data.message, 1000);
            vmac.checkedPostsforUpdate = [];
            vmac.checkedPostsEdit = [];
            vmac.tableParams.reload();
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
           
          }
          vmac.checkedPostsforUpdate = [];
          vmac.checkedPostsEdit = [];
          $rootScope.hasLoaded = true;
        });
      }
      putFunction();
    }
    vmac.updateStatusPost = function(post_id, status) {
      vmac.checkedPostsforUpdate = [];
      if(vmac.commentsType =='video') {
        putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
      } else {
        putPostsFunction(API_URL + 'comments/bulk/'+status);
      }
      vmac.checkedPostsforUpdate.push(post_id);
      watchAllCheckboxesNgTable.resetCheckBox(vmac)
    }

    vmac.bulkAction = function(status) {
      vmac.checkedPostsforUpdate = [];
      arrayPostsIdFunction();
      if(status != "default" && vmac.checkedPostsforUpdate.length > 0) {
        if(vmac.commentsType =='video') {
          putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
        } else {
          putPostsFunction(API_URL + 'comments/bulk/'+status);
        }
        watchAllCheckboxesNgTable.resetCheckBox(vmac)
        // vmac.tableParams.reload();
      } 
    }
    watchAllCheckboxesNgTable.watch($scope, vmac, false, 'comment_ID')
    vmac.checkedPost = function(postId,checked) {
      if (checked) {
        vmac.checkedPostsEdit.push(postId);
      } else {
       var index = vmac.checkedPostsEdit.indexOf(postId);
       if(index > -1) {
        vmac.checkedPostsEdit.splice(index, 1);
       } 
      }
      
    }
    vmac.changeSearch = function(evt) {
      evt = (evt) ? evt : event;
        var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
        ((evt.which) ? evt.which : 0));
        if (charCode > 32 && (charCode < 48 || charCode > 57) ) {
            evt.preventDefault();
        }
    }
    vmac.searchComment = function(value) {
      if(value) {
        vmac.commentPostId = value;
        vmac.serchCommentsModalShow = true;
        $rootScope.modalShow = true;
      }
    } 
    vmac.closeSearchComment = function() {
      vmac.serchCommentsModalShow = false;
      vmac.commentPostId = null;
      $rootScope.modalShow = false;
    }
    vmac.tableActionsFunction = function(params) {
      var reloadTableFunction = function() {
        params.page(1);
        vmac.tableParams.reload();
      }
      vmac.changeStatus =function(event,activeStatus) {
        vmac.status = activeStatus;
        status = activeStatus;
        vmac.postId = null;
        vmac.searchData = null;
        if(activeStatus == 'approved') {
          vmac.statusApproved = true;
          vmac.statusTrash = false;
        } else {
          vmac.statusApproved = false;
        }
        if(activeStatus == 'trashed' || activeStatus == 'spam') {
          vmac.statusApproved = false;
          vmac.statusTrash = true;
        } else {
          vmac.statusTrash = false;
        }
        reloadTableFunction();
      }
      // vmac.switchPriorityFilter = function() {
      //   reloadTableFunction();
      // }
    }
    vmac.tableReloadFunction = function(page) {
      vmac.tableParams = new NgTableParams({
            page: page || 1,
            count: 20,
            
        }, {
        getData: function(params) {
          
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            status: status,
            // priority: (vmac.selectedPriorityFilter.value !='all')? vmac.selectedPriorityFilter.value:null, 
            type:(vmac.commentsType == 'video')? 'video':null,
            page: params.page(),
            limit: params.count(),
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            }).$promise.then(function(data){
           
            $rootScope.emptyTable = false;
            $rootScope.hasLoaded = true;
            $data = data.comments;
            vmac.dataGet = data.comments;
            if(data.comments.length == 0) {
              $rootScope.emptyTable = true;
            } 
            watchAllCheckboxesNgTable.resetCheckBox(vmac)
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            vmac.selectedBulkAction = {value: 'default'};
            for(var i=0; i<vmac.dataGet.length;i++) {
              vmac.parrent[vmac.dataGet[i].comment_ID] = false;
              if(vmac.dataGet[i].parrent) {
                vmac.parrent[vmac.dataGet[i].comment_ID] = true;
              }
              if(config.highlightWordsActive && config.highlightWordsDiacritics && config.highlightWordsDiacritics.length>0) {
                vmac.dataGet[i].comment_author = cyrilicToLatin(vmac.dataGet[i].comment_author) 
                vmac.dataGet[i].comment_author = highlightWords(vmac.dataGet[i].comment_author, config.highlightWordsDiacritics)
                vmac.dataGet[i].comment_content = cyrilicToLatin(vmac.dataGet[i].comment_content) 
                vmac.dataGet[i].comment_content = highlightWords(vmac.dataGet[i].comment_content, config.highlightWordsDiacritics)
              }
            }
            vmac.tableActionsFunction(params);
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
               
                if(answer==200) {
                  vmac.tableReloadFunction(params.page());
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
            vmac.tableActionsFunction(params);
          });
        }    
      });
    }
    vmac.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/allcomments/js/allcommentsController.js
// module id = 493
// module chunks = 0